import { emptyMainUrls } from '../consts/emptyMainUrls';
import MAIN_MODULES from '../../../../../config/modules/main.json'
import { MinimalModule, IMicrofront, MinimalVersion } from '../../../interfaces/MFE/IMicrofront';
import { getModuleVersionURL } from '../../versions/get-version-url';

export function getMainModulesUrl( microfronts: {
    discovered: IMicrofront[], 
    downloaded: MinimalVersion[]
} ){

    const mainUrls = emptyMainUrls
    for (const mainModule of MAIN_MODULES as MinimalModule[]) {
        mainUrls[mainModule.mfe_name] = getModuleVersionURL({featureId: mainModule.mfe_id, microfronts} )
    }

    return mainUrls

}